<template>
  <div
    v-if="show"
    class="modalOverlay"
    @click.self="closeModal"
  >
    <div class="modalCard">
      
      <header class="modalHeader">
        <h3>{{ title }}</h3>
        <button
          class="modalClose"
          @click="closeModal"
        >
          ×
        </button>
      </header>

      <div class="modalBody">
        <ArrayPrinter
          ref="table"
          :items="infoOperatorArray"
          @nextModal="nextModal"
        />
      </div>

      <footer class="modalFooter">
        <button
          class="loginbtn primaryBtn"
          @click="confirmAction"
        >
          Aceptar
        </button>

        <button
          class="loginbtn secondaryBtn"
          @click="closeModal"
        >
          Cancelar
        </button>
      </footer>

    </div>
  </div>
</template>

<script>
import ArrayPrinter from './impresionData.vue'

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: 'Título del Modal',
    },
    infoOperatorArray: {
      type: Array,
      required: true,
    },
  },
  components: {
    ArrayPrinter,
  },
  emits: ['close', 'confirm'],
  methods: {
    closeModal () {
      this.$emit('close')
    },
    confirmAction () {
      this.$refs.table.callTableSon()
    },
    nextModal(){
      this.$emit('nextModal')
    }
  },
}
</script>